exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-423fec14] {\n  margin-top: 0.45rem;\n}\n.no-bg[data-v-423fec14] {\n  background-color: white !important;\n}\n", ""]);
